"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityEventObserver = void 0;
var inversify_1 = require("inversify");
var notifyEvents_1 = require("../constants/notifyEvents");
var session_1 = require("../constants/session");
var types_1 = require("../types");
var IRouteStackService_1 = require("./IRouteStackService");
var VisibilityEventObserver = /** @class */ (function () {
    function VisibilityEventObserver() {
    }
    VisibilityEventObserver.prototype.addRouteAndReEnter = function (routeType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.routeStackService.addByType(routeType)];
                    case 1:
                        _a.sent();
                        // 重新触发进入事件
                        this.observableService.notify(notifyEvents_1.NOTIFY_ROUTE_RE_ENTER);
                        return [2 /*return*/];
                }
            });
        });
    };
    VisibilityEventObserver.prototype.handleVisibilityChange = function (visibilityState) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionExpired;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(visibilityState === "visible")) return [3 /*break*/, 9];
                        this.exposeService.reCollect();
                        this.exposeService.exposeAfterReCollect({ force: true });
                        // 将当前页面设置为激活tab
                        return [4 /*yield*/, this.activeTabService.setCurrentToActive()];
                    case 1:
                        // 将当前页面设置为激活tab
                        _a.sent();
                        return [4 /*yield*/, this.sessionService.isExpired()];
                    case 2:
                        sessionExpired = _a.sent();
                        if (!sessionExpired) return [3 /*break*/, 5];
                        // 重新生成会话信息 没有uid时，不重新生成会话id
                        return [4 /*yield*/, this.sessionService.generate()];
                    case 3:
                        // 重新生成会话信息 没有uid时，不重新生成会话id
                        _a.sent();
                        return [4 /*yield*/, this.addRouteAndReEnter(IRouteStackService_1.RouteType.Expired)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 5: 
                    // 此 tab 重新 visible，增加路由信息，实际会保存原有的部分信息
                    return [4 /*yield*/, this.addRouteAndReEnter(IRouteStackService_1.RouteType.MultiTab)];
                    case 6:
                        // 此 tab 重新 visible，增加路由信息，实际会保存原有的部分信息
                        _a.sent();
                        _a.label = 7;
                    case 7: return [4 /*yield*/, this.leaveOpsService.makePrevRouteLeave()];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        if (!(visibilityState === "hidden")) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.leaveOpsService.makeCurrentRouteLeave()];
                    case 10:
                        _a.sent();
                        return [4 /*yield*/, this.exposeService.exposeImmediately({
                                send: true,
                            })];
                    case 11:
                        _a.sent();
                        return [4 /*yield*/, this.localStoreService.setItem(session_1.VISIBLE_TIME_KEY, "".concat(Date.now()))];
                    case 12:
                        _a.sent();
                        _a.label = 13;
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    VisibilityEventObserver.prototype.update = function (visibilityState) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.handleVisibilityChange(visibilityState)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); });
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IObservableService),
        __metadata("design:type", Object)
    ], VisibilityEventObserver.prototype, "observableService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IRouteStackService),
        __metadata("design:type", Object)
    ], VisibilityEventObserver.prototype, "routeStackService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IStoreService),
        (0, inversify_1.named)(types_1.TAG.LocalStoreService),
        __metadata("design:type", Object)
    ], VisibilityEventObserver.prototype, "localStoreService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.ISessionService),
        __metadata("design:type", Object)
    ], VisibilityEventObserver.prototype, "sessionService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IActiveTabService),
        __metadata("design:type", Object)
    ], VisibilityEventObserver.prototype, "activeTabService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IApplicationExecutor),
        __metadata("design:type", Object)
    ], VisibilityEventObserver.prototype, "applicationExecutor", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.ILeaveOpsService),
        __metadata("design:type", Object)
    ], VisibilityEventObserver.prototype, "leaveOpsService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IExposeService),
        __metadata("design:type", Object)
    ], VisibilityEventObserver.prototype, "exposeService", void 0);
    VisibilityEventObserver = __decorate([
        (0, inversify_1.injectable)()
    ], VisibilityEventObserver);
    return VisibilityEventObserver;
}());
exports.VisibilityEventObserver = VisibilityEventObserver;
